<template>
  <div
    class="menu-wrapper right-menu"
    id="js_right_menu"
    v-show="isShow"
    :style="styObj"
    ref="menuwrapper"
    @click.stop
  >
    <ul class="menu-items">
      <li
        class="menu-item"
        @mousedown.stop.prevent
        :class="{'no-do': !item.abled}"
        v-for="(item, index) in menuList"
        :key="index"
        :data-type="item.val"
        @click.stop="doClick($event, item)"
      >{{item.val}}</li>
    </ul>
  </div>
</template>

<script>
// const Clipboard = require('clipboard')

export default {
  data () {
    return {
      isShow: false,
      clipboard: undefined
    }
  },
  mounted () {
    this.isShow = true
    document.addEventListener('click', this.close)
    document.addEventListener('keydown', this.closeByEsc)
  },
  methods: {
    doClick (event, item) {
      event.preventDefault()
      event.stopPropagation()
      if (!item.abled) return
      this.callback(item, this.activeItem)
    },
    close (e) {
      if (this.isShow && this.target !== e) {
        console.log(this.isShow, this.target, e)
        this.isShow = false
        this.$emit('closed')
      }
    },
    closeByEsc (e) {
      if (e.keyCode === 27) {
        this.close()
      }
    }
  },
  destroyed () {
    document.removeEventListener('click', this.close)
    document.removeEventListener('keydown', this.closeByEsc)
  },
  computed: {
    styObj () {
      // if (!this.posobj || !this.posobj.left || !this.posobj.top) {
      //   return
      // }
      // let docuHeight = document.body.clientHeight
      // let menuHeight = this.list.length * 37 + 2
      // if (this.posobj.top > docuHeight - menuHeight) {
      //   return {
      //     left: `${this.posobj.left}px`,
      //     bottom: '0'
      //   }
      // }
      let { left } = this.posobj
      const minWidth = 80
      const distance = document.body.clientWidth - left
      if (distance < minWidth) {
        left -= (distance + 20)
      }
      return {
        left: `${left}px`,
        top: `${this.posobj.top}px`
      }
    }
  }
}
</script>

<style lang="scss"  scoped>
.menu-wrapper {
  * {
    margin: 0;
    padding: 0;
  }
  li {
    list-style: none;
  }
}
.menu-wrapper {
  position: fixed;
  z-index: 99999;
  background-color: #ffffff;
  box-shadow: #ccc 1px 1px 10px;
  min-width: 80px;
  border-radius: 4px;
  .menu-item {
    // border-top: 1px solid $c-bc-1;
    line-height: 32px;
    box-sizing: border-box;
    text-align: center;
    font-size: 14px;
    padding: 0 16px;
    cursor: pointer;
    &:hover {
      background-image: linear-gradient(
        rgba(255, 255, 255, 0.9),
        rgba(255, 255, 255, 0.9)),
      linear-gradient(
        #E0BD7B,
        #E0BD7B);
    }
    &.no-do {
      color: #ddd;
      cursor: default;
      &:hover {
        background-color:#ffffff;
      }
    }
    &:first-child {
      border-top: none;
    }
  }
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.2s ease;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
</style>
